import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-banner-cadastro',
  templateUrl: './banner-cadastro.component.html',
  styleUrls: ['../../page/banner/banner-shared.scss'],
})
export class BannerCadastroComponent {

  @Input() formulario!: FormGroup;
  @Input() bannerBase64: string | ArrayBuffer | null = null;

  @Output() anexarArquivo = new EventEmitter<Event>();
}
